export default __webpack_public_path__ + "static/media/DashedBlue.764b5f12.svg";